export const agencies = ({ token, agencies, client }) => ({
  HTTPMethod: "get",
  path: "/agencies",
  queryParams: {
    agencies,
    client,
  },
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  body: {},
});
